import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { translate } from '@jsverse/transloco';
import { Constants } from 'src/app/models/constants';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { InstancesService } from 'src/app/services/api/instances.service';
import { SweetAlertService } from 'src/app/services/util/sweet-alert.service';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
  @Component({
    selector: 'app-create-instance',
    templateUrl: './create-instance.component.html',
    styleUrls: ['./create-instance.component.scss'],
    standalone: false
})
  export class CreateInstanceComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
  @Input() set data(data: any) {
    this.editData = data;
  };
  @Input() edit;
  editData: any;
  Constants = Constants;
  title: string;
  createInstanceForm: FormGroup;
  endPointForm: FormGroup[] = [];
  productForm: FormGroup[] = [];
  lineOfBusinessOptions: any;
  regionOptions: any;
  categoryOptions: any;
  statusOptions: any;
  occurrences: any[];
  productOccurrences: any[];
  index: number;
  productIndex: number;
  formConfig: any;
  isLoading = false;
  dataZone: any = ['development', 'secure', 'live'];
  deploymentClass: any = ['A', 'B', 'C', 'D'];
  // eslint-disable-next-line max-len
  status: any = ['deploying', 'deployed', 'failed', 'terminating', 'terminated', 'termination_failed', 'configuring', 'configured', 'configuration_failed', 'updating', 'updated', 'update_failed'];
  managementType: any = ['external', 'external_for_action'];
  externalOrigination: any = ['ADO', 'manual'];
  useType: any = ['configuration', 'ui', 'api', 'other'];

  constructor(private formBuilder: FormBuilder, public sidenavService: SidenavService, private solutionsService: SolutionsService,
    private dialog: MatDialog, public instancesService: InstancesService, private sweetAlertService: SweetAlertService, private toastrService: CustomToastrService) { 
      
    }

  ngOnInit(): void {
    this.title = translate('ADD_INSTANCE.ADD_INSTANCE');
    this.createForm();
  }

  getDeployment(): any {
    let failed = false;
    if (!FormUtilService.validateForm(this.createInstanceForm)) {
      return;
    }
    this.endPointForm.forEach(media => {
      if (media && !FormUtilService.validateForm(media)) {
        failed = true;
      }
    });
    this.productForm.forEach(media => {
      if (media && !FormUtilService.validateForm(media)) {
        failed = true;
      }
    });
    if (failed) {
      return;
    } else {
      return this.createInstanceForm.getRawValue();
    }
  }

  /**
   * On clicking submit button, A new instance will get deployed.
   */
  createDeployment(): void {
    if (!this.getDeployment()) {
      return;
    }
    let mediaList = [];
    this.endPointForm.forEach(media => {
      mediaList = [...mediaList, media.getRawValue()];
    });
    let productList: any = [];
    this.productForm.forEach(product => {
      productList = [...productList, product.getRawValue()];
    });
    const obj = this.getDeployment();
    obj.endpoints = mediaList;
    obj.temenosProducts = {};
    productList.forEach(product => {
      obj.temenosProducts[product.name] = product.version;
    });
    const formData = obj;
    const form: any = formData;
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('ADD_INSTANCE.TITLE'),
        message:translate('ADD_INSTANCE.MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.isLoading = true;
          this.instancesService.addInstance(form)
          // eslint-disable-next-line rxjs-angular/prefer-takeuntil
          .subscribe(data => {
            if (data) {
              this.isLoading = false;
              this.sidenavService.closeRightSidenav(obj);
            setTimeout(() => {
              const message = translate('INSTANCE_DETAILS.CREATE_DEPLOYMENT_SUCCESS');
              const title = translate('INSTANCE_DETAILS.INSTANCE'); 
              this.toastrService.successMessage(message, title);
            }, 500)
            }
          },
          (error) => {
            this.isLoading = false;
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('ERROR_DIALOG.ADD_INSTANCE_FAILED'),
                description: errorMessage
              }
            });
          });
        }
      });
  }

  createForm(): void {
    const formConfig: any = {
      tenantId: ['', [Validators.required]],
      name: ['', [Validators.required]],
      randomSuffix: ['', [Validators.required]],
      dataZone: ['', [Validators.required]],
      deploymentClass: ['', [Validators.required]],
      status: ['', [Validators.required]],
      primaryCloudRegion: ['', [Validators.required]],
      secondaryCloudRegion: [''],
      managementType: ['', [Validators.required]],
      externalOrigination: ['', [Validators.required]],
      adoPipeline: ['', [Validators.required]],
      adoVariableGroup: ['', [Validators.required]],
      AKSVersion: ['', [Validators.required]],
      dynatraceUrl: ['', [Validators.required]],
    };
    this.createInstanceForm = this.formBuilder.group(formConfig);

    if (this.editData) {
      const keys = Object.keys(formConfig);
      const values = this.editData;
      keys.forEach(key => {
        if (values[key]) {
          this.createInstanceForm.get(key).setValue(values[key]);
        }
      });
      this.addProductsForm();
      this.addMediaForm();
    }
  }

  createMediaForm(): void {
    this.formConfig = {
      name: ['', [Validators.required]],
      description: ['', [Validators.required]],
      url: ['', [Validators.required]],
      useType: ['', [Validators.required]]
    };
    this.endPointForm[this.index] = this.formBuilder.group(this.formConfig);
  }

  createProductsForm(): void {
    this.formConfig = {
      name: ['', [Validators.required]],
      version: ['', [Validators.required]]
    };
    this.productForm[this.productIndex] = this.formBuilder.group(this.formConfig);
  }

  addMediaForm(): void {
    if (this.editData.media?.length > 0) {
      this.editData.media?.forEach(item => {
        this.index = (this.index || this.index === 0) ? this.index + 1 : 0;
        this.createMediaForm();
        const keys = Object.keys(this.formConfig);
        const values = item;
        keys.forEach(key => {
          if (values[key]) {
            this.endPointForm[this.index].get(key).setValue(values[key]);
          }
        });
        this.occurrences = this.occurrences && this.occurrences.length !== 0 ?
          [...this.occurrences, this.occurrences[this.occurrences.length - 1] + 1] : [0];
      });
    }
  }

  addProductsForm(): void {
    if (this.editData.media?.length > 0) {
      this.editData.media?.forEach(item => {
        this.productIndex = (this.productIndex || this.productIndex === 0) ? this.productIndex + 1 : 0;
        this.createProductsForm();
        const keys = Object.keys(this.formConfig);
        const values = item;
        keys.forEach(key => {
          if (values[key]) {
            this.productForm[this.productIndex].get(key).setValue(values[key]);
          }
        });
        this.productOccurrences = this.productOccurrences && this.productOccurrences.length !== 0 ?
          [...this.productOccurrences, this.productOccurrences[this.productOccurrences.length - 1] + 1] : [0];
      });
    }
  }


  addMediaOccurrence(): void {
    this.index = (this.index || this.index === 0) ? this.index + 1 : 0;
    this.createMediaForm();
    this.occurrences = this.occurrences && this.occurrences.length !== 0 ?
      [...this.occurrences, this.occurrences[this.occurrences.length - 1] + 1] : [0];

  }

  addProductsOccurrence(): void {
    this.productIndex = (this.productIndex || this.productIndex === 0) ? this.productIndex + 1 : 0;
    this.createProductsForm();
    this.productOccurrences = this.productOccurrences && this.productOccurrences.length !== 0 ?
      [...this.productOccurrences, this.productOccurrences[this.productOccurrences.length - 1] + 1] : [0];

  }

  deleteMediaOccurrence(i): void {
    this.occurrences.splice(-1, 1);
    this.index = this.index - 1;
    this.endPointForm.splice(i, 1);
    this.endPointForm = this.endPointForm;
  }

  deleteProductsOccurrence(i): void {
    this.productOccurrences.splice(-1, 1);
    this.productIndex = this.productIndex - 1;
    this.productForm.splice(i, 1);
    this.productForm = this.productForm;
  }

}





